module.exports = __webpack_public_path__ + "img/DiscoveringYourStrengths.e63e0ea5.jpg";